export default "__VITE_ASSET__BzKimb$x__"